import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTimelineStyles } from '../../../hooks/use-timeline-styles'

export const TimelineHoverLineRect = ({ x, dateStr, show }) => {
  const { TimelineStyles } = useTimelineStyles()

  if (!show) return null

  return (
    <Box sx={{ position: 'sticky', top: 0, height: 0, zIndex: 20, pointerEvents: 'none' }}>
      <Box
        sx={{
          position: 'absolute',
          left: x - 25,
          top: 0,
          width: 50,
          height: 16,
          bgcolor: TimelineStyles.hover.fillColor,
          borderRadius: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography sx={{ fontSize: '9px', fontWeight: 'bold', color: TimelineStyles.hover.textColor }}>
          {dateStr}
        </Typography>
      </Box>
    </Box>
  )
}
